import React from "react";
import { Tr, InputNumerText, InputDate, ComboNormal } from "../components";

function classNames(...classes){
  return classes.filter(Boolean).join(" ")
}

const Alumno = ({ values, setValues, handleDate, generos, getDatosAlumno }) => {
  return (
    <div className="flex flex-row ">
      
      <div className="w-1/4 m-auto">
        <img
          
          src={`${values["fotosWeb"]}`}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = "./img/cursos/defaultImage.jpg";
          }}
          className=" rounded-md shadow-md m-auto w-[50%] h-[50%]"
        ></img>
      </div>
      <div className="w-3/4 ">
      <p className="text-azulBrillanteMira text-xl font-medium">Datos</p>
        <Tr
          cols={"2"}
          title=""
          gap="2"
          dist={[1, 1]}
          children={[
            <div className="shadow p-2 rounded-md bg-secundarioMira flex flex-col justify-between gap-2"> {/* controlar los hijos */}
              {/*<p className="text-white text-xl font-medium">Datos de alumno</p>*/}
              <div className="h-2/3 bg-primarioMira rounded-md">
              <Tr
                cols={"5 rounded-md px-1 content-center grid"}
                title=""
                gap="2"
                separad={true}
                dist={[5, 2, 1, 2, 5,2,1]}
                children={[
                  <p className="text-secundario text-lg /px-1 ">
                  Datos de alumno
                  </p>,

                  <div className="">
                    <label className="text-white font-medium">{"Nombre"}</label>
                    <p className="text-gray-400  my-auto">
                      {values.NombreCompletoAlumno}
                    </p>
                  </div>,

                  <div>
                    <label className="text-white font-medium">{"Carnet"}</label>
                    <p className="text-gray-400  my-auto">{values.Carnet}</p>
                  </div>,
                  <div>
                    <label className="text-white font-medium">{"Sede"}</label>
                    <p className="text-gray-400 my-auto">{values.Sede}</p>
                  </div>,
                  <div>
                  <label className="text-white font-medium">
                    {"Dirección"}
                  </label>
                  <p className="text-gray-400  my-auto">{values.Direcc}</p>
                </div>,

                <div>
                <label className="text-white font-medium">
                  {"Fecha de nacimiento"}
                </label>
                <p className="text-gray-400  my-auto">{values.FechaNac}</p>
              </div>,

                <div>
                <label className="text-white font-medium">
                  {"Familia"}
                </label>
                <p className="text-gray-400  my-auto">{values.IdFamilia}</p>
                </div>,
                ]}
                ></Tr>
                </div>

                <div className="h-1/3 bg-primarioMira rounded-md content-center grid">
              <Tr
                cols={"5  rounded-md px-1"}
                title=""
                separad={true}
                gap="2"
                dist={[ 2, 1, 2,]}
                children={[
                  <div>
                  <label className="text-white font-medium">{"Grado actual / último cursado"}</label>
                  <p className="text-gray-400  my-auto">{values.Grado}</p>
                </div>,
                <div>
                  <label className="text-white font-medium">
                    {"Estado actual"}
                  </label>
                  <p className={(classNames(values.EstadoActual == "Activo" ? "bg-green-500": "bg-red-500", "font-medium my-auto inline-block p-1 rounded-xl text-white"))}>
                    {values.EstadoActual}
                  </p>
                </div>,
                  <div>
                  <p className="text-white font-medium">
                    Último ciclo cursado
                  </p>
                  <p className="text-gray-400">{values.UltimoCiclo}</p>
                </div>,
                ]}
                ></Tr>
                </div>
            </div>,
            <div className="shadow p-2 rounded-md flex flex-col bg-secundarioMira gap-2">
              {/*<p className="text-white text-xl font-medium">Detalle de pagos</p>*/}
              <Tr
                cols={"3"}
                separad={true}
                title=""
                gap="0  bg-primarioMira rounded-t"
                dist={["3","1","1","1","3"]} //nombremadre, telefonomadre, correomadre nombrepadre,telefonopadre, correopadre, nombreencargado telefonoencargado, correoencargado
                children={[
                  <p className="text-secundario text-lg px-1 ">
                  Datos de encargado
                  </p>,
                  <div className=" p-1">
                    <label className="text-white font-medium">{"Nombre"}</label>
                    <p className="text-gray-400  my-auto">
                      {values.NombreCompletoEncargado}
                    </p>
                  </div>,
                  <div className=" p-1">
                    <label className="text-white font-medium">
                      {"Teléfono"}
                    </label>
                    <p className="text-gray-400  my-auto">{values.CelEnvioSMS}</p>
                  </div>,
                  <div className=" p-1 rounded-tr-md">
                    <label className="text-white font-medium">{"Correo"}</label>
                    <p className="text-gray-400  my-auto">{values.EmailT}</p>
                  </div>,
              <div className="bg-primarioMira rounded-md p-1">
                <label className="text-white font-medium">{"Dirección"}</label>
                <p className="text-gray-400  my-auto">{values.E_Direcc}</p>
              </div>
                ]}
              ></Tr>


              
              <Tr
                cols={"3"}
                title=""
                gap="2  bg-primarioMira rounded-t"
                dist={["3","1","1","1","3"]} //nombremadre, telefonomadre, correomadre nombrepadre,telefonopadre, correopadre, nombreencargado telefonoencargado, correoencargado
                children={[
                  <p className="text-secundario text-lg px-1">
                  Datos de padre
                  </p>,
                  <div className=" p-1">
                    <label className="text-white font-medium">{"Nombre"}</label>
                    <p className="text-gray-400  my-auto">
                      {values.P_NombreCompleto}
                    </p>
                  </div>,
                  <div className=" p-1">
                    <label className="text-white font-medium">
                      {"Teléfono"}
                    </label>
                    <p className="text-gray-400  my-auto">{values.P_Cel}</p>
                  </div>,
                  <div className=" p-1">
                    <label className="text-white font-medium">{"Correo"}</label>
                    <p className="text-gray-400  my-auto">{values.P_Email}</p>
                  </div>,
              <div className="bg-primarioMira rounded-md p-1">
                <label className="text-white font-medium">{"Dirección"}</label>
                <p className="text-gray-400  my-auto">{values.P_Direcc}</p>
              </div>
                ]}
              ></Tr>


              <Tr
                cols={"3"}
                title=""
                gap="2  bg-primarioMira rounded-t"
                dist={["3","1","1","1","3"]} //nombremadre, telefonomadre, correomadre nombrepadre,telefonopadre, correopadre, nombreencargado telefonoencargado, correoencargado
                children={[
                    <p className="text-secundario text-lg px-1">
                      Datos de madre
                    </p>,
                  <div className=" p-1">
                    <label className="text-white font-medium">{"Nombre"}</label>
                    <p className="text-gray-400 my-auto">
                      {values.P_NombreCompleto}
                    </p>
                  </div>,
                  <div className=" p-1">
                    <label className="text-white font-medium">
                      {"Teléfono"}
                    </label>
                    <p className="text-gray-400 my-auto">{values.M_Cel}</p>
                  </div>,
                  <div className=" p-1">
                    <label className="text-white font-medium">{"Correo"}</label>
                    <p className="text-gray-400 my-auto">{values.M_Email}</p>
                  </div>,
                  <div className="bg-primarioMira rounded-md p-1">
                    <label className="text-white font-medium">{"Dirección"}</label>
                    <p className="text-gray-400 my-auto">{values.M_Direcc}</p>
                  </div>
                ]}
              ></Tr>
            </div>,


            
          ]}
        />
      </div>
    </div>
  );
};

export default Alumno;
